export const translations = {
  fr: {
    nav: {
      home: 'Accueil',
      mission: 'Notre Mission',
      expertise: 'Expertise',
      projects: 'Réalisations',
      growth: 'Notre Croissance',
      team: 'Équipe',
      contact: 'Contact'
    },
    hero: {
      title: 'BK Tech',
      subtitle: 'Création d\'applications sur mesure, puissantes et innovantes',
      cta: 'Nous contacter'
    },
    why: {
      title: 'Pourquoi BK Tech ?',
      items: [
        {
          title: 'Innovation',
          description: 'Technologies de pointe pour des solutions modernes'
        },
        {
          title: 'Sur-mesure',
          description: 'Applications adaptées à vos besoins spécifiques'
        },
        {
          title: 'Excellence',
          description: 'Qualité et performance au cœur de nos développements'
        },
        {
          title: 'Performance',
          description: 'Systèmes rapides, fiables et scalables'
        }
      ]
    },
    mission: {
      title: 'Notre Mission',
      description: 'Chez BK Tech, nous créons des applications performantes qui transforment vos idées en solutions digitales puissantes. Notre expertise technique et notre passion pour l\'innovation nous permettent de concevoir des produits sur-mesure qui dépassent vos attentes.'
    },
    expertise: {
      title: 'Notre Expertise',
      items: [
        {
          title: 'Développement Full-Stack',
          description: 'Applications web et mobile avec les technologies les plus récentes'
        },
        {
          title: 'Solutions Trading & Crypto',
          description: 'Plateformes sécurisées pour le trading et les cryptomonnaies'
        },
        {
          title: 'Automatisation & API',
          description: 'Intégrations intelligentes et automatisation de processus'
        },
        {
          title: 'UI/UX Design Pro',
          description: 'Interfaces modernes et expériences utilisateur optimales'
        }
      ]
    },
    projects: {
      title: 'Nos Réalisations',
      subtitle: 'Des applications sur mesure qui font la différence',
      items: [
        {
          title: 'Plateforme de Trading',
          description: 'Interface en temps réel pour le trading professionnel'
        },
        {
          title: 'Solution Crypto',
          description: 'Gestion de portefeuille et analyse de marché'
        },
        {
          title: 'Dashboard Analytics',
          description: 'Visualisation de données et business intelligence'
        },
        {
          title: 'Nos projets sur mesure',
          description: 'Solutions personnalisées adaptées à vos besoins'
        }
      ]
    },
    growth: {
      title: 'Notre Croissance depuis 2021',
      subtitle: 'Une évolution constante portée par l\'innovation',
      stats: [
        {
          year: '2021',
          revenue: '1.4M€',
          clients: 5,
          projects: 8
        },
        {
          year: '2022',
          revenue: '4.4M€',
          clients: 15,
          projects: 25
        },
        {
          year: '2023',
          revenue: '8.8M€',
          clients: 35,
          projects: 50
        },
        {
          year: '2024',
          revenue: '15M€',
          clients: 60,
          projects: 85
        },
        {
          year: '2025',
          revenue: '21M€',
          clients: 85,
          projects: 120
        }
      ],
      highlights: [
        {
          number: '150+',
          label: 'Projets réalisés'
        },
        {
          number: '85+',
          label: 'Clients satisfaits'
        },
        {
          number: '21M€',
          label: 'Chiffre d\'affaires 2025'
        },
        {
          number: '1400%',
          label: 'Croissance depuis 2021'
        }
      ]
    },
    team: {
      title: 'L\'Équipe Dirigeante',
      members: [
        {
          name: 'Benjamin Hadjedj',
          role: 'CTO & Lead Developer',
          description: 'Expert en architecture logicielle et développement full-stack'
        },
        {
          name: 'Kevin Cohen',
          role: 'Head of Partnerships',
          description: 'Spécialiste en stratégie et développement commercial'
        }
      ]
    },
    testimonials: {
      title: 'Témoignages',
      items: [
        {
          name: 'Marie Dubois',
          company: 'TechStart SAS',
          text: 'BK Tech a transformé notre vision en une application exceptionnelle. Professionnalisme et expertise au rendez-vous.'
        },
        {
          name: 'Thomas Martin',
          company: 'FinanceHub',
          text: 'Une équipe réactive qui comprend nos besoins. Notre plateforme de trading fonctionne parfaitement.'
        },
        {
          name: 'Sophie Bernard',
          company: 'Digital Learning',
          text: 'Résultat au-delà de nos attentes. Une solution sur-mesure qui correspond exactement à nos besoins.'
        },
        {
          name: 'Alexandre Rousseau',
          company: 'CryptoVision',
          text: 'Développement crypto impeccable. BK Tech a su gérer la complexité technique avec brio.'
        },
        {
          name: 'Camille Petit',
          company: 'Analytics Pro',
          text: 'Dashboard performant et intuitif. L\'équipe BK Tech est ultra-compétente et à l\'écoute.'
        },
        {
          name: 'Laurent Dubois',
          company: 'PropTech Solutions',
          text: 'Application immobilière moderne et fluide. Excellent travail de A à Z.'
        }
      ]
    },
    contact: {
      title: 'Contactez-nous',
      subtitle: 'Prenons rendez-vous pour discuter de votre projet',
      form: {
        name: 'Nom complet',
        email: 'Email',
        phone: 'Téléphone',
        message: 'Message',
        submit: 'Envoyer',
        success: 'Message envoyé avec succès !',
        error: 'Veuillez remplir tous les champs correctement'
      },
      info: {
        email: 'contact@bktech.dev',
        phone: '+33 7 80 91 34 57'
      }
    },
    footer: {
      copyright: '© 2025 BK Tech. Tous droits réservés.',
      legal: 'Mentions légales'
    }
  },
  en: {
    nav: {
      home: 'Home',
      mission: 'Our Mission',
      expertise: 'Expertise',
      projects: 'Projects',
      growth: 'Our Growth',
      team: 'Team',
      contact: 'Contact'
    },
    hero: {
      title: 'BK Tech',
      subtitle: 'We build smart, powerful, and innovative digital experiences',
      cta: 'Contact us'
    },
    why: {
      title: 'Why BK Tech?',
      items: [
        {
          title: 'Innovation',
          description: 'Cutting-edge technologies for modern solutions'
        },
        {
          title: 'Custom-made',
          description: 'Applications tailored to your specific needs'
        },
        {
          title: 'Excellence',
          description: 'Quality and performance at the heart of our developments'
        },
        {
          title: 'Performance',
          description: 'Fast, reliable and scalable systems'
        }
      ]
    },
    mission: {
      title: 'Our Mission',
      description: 'At BK Tech, we create high-performance applications that transform your ideas into powerful digital solutions. Our technical expertise and passion for innovation enable us to design custom products that exceed your expectations.'
    },
    expertise: {
      title: 'Our Expertise',
      items: [
        {
          title: 'Full-Stack Development',
          description: 'Web and mobile applications with the latest technologies'
        },
        {
          title: 'Trading & Crypto Solutions',
          description: 'Secure platforms for trading and cryptocurrencies'
        },
        {
          title: 'Automation & API',
          description: 'Smart integrations and process automation'
        },
        {
          title: 'Professional UI/UX Design',
          description: 'Modern interfaces and optimal user experiences'
        }
      ]
    },
    projects: {
      title: 'Our Projects',
      subtitle: 'Custom applications that make a difference',
      items: [
        {
          title: 'Trading Platform',
          description: 'Real-time interface for professional trading'
        },
        {
          title: 'Crypto Solution',
          description: 'Portfolio management and market analysis'
        },
        {
          title: 'Analytics Dashboard',
          description: 'Data visualization and business intelligence'
        },
        {
          title: 'Custom Projects',
          description: 'Personalized solutions tailored to your needs'
        }
      ]
    },
    growth: {
      title: 'Our Growth since 2021',
      subtitle: 'Constant evolution driven by innovation',
      stats: [
        {
          year: '2021',
          revenue: '1.4M€',
          clients: 5,
          projects: 8
        },
        {
          year: '2022',
          revenue: '4.4M€',
          clients: 15,
          projects: 25
        },
        {
          year: '2023',
          revenue: '8.8M€',
          clients: 35,
          projects: 50
        },
        {
          year: '2024',
          revenue: '15M€',
          clients: 60,
          projects: 85
        },
        {
          year: '2025',
          revenue: '21M€',
          clients: 85,
          projects: 120
        }
      ],
      highlights: [
        {
          number: '150+',
          label: 'Projects completed'
        },
        {
          number: '85+',
          label: 'Satisfied clients'
        },
        {
          number: '21M€',
          label: '2025 Revenue'
        },
        {
          number: '1400%',
          label: 'Growth since 2021'
        }
      ]
    },
    team: {
      title: 'Leadership Team',
      members: [
        {
          name: 'Benjamin Hadjedj',
          role: 'CTO & Lead Developer',
          description: 'Expert in software architecture and full-stack development'
        },
        {
          name: 'Kevin Cohen',
          role: 'Head of Partnerships',
          description: 'Specialist in strategy and business development'
        }
      ]
    },
    testimonials: {
      title: 'Testimonials',
      items: [
        {
          name: 'Marie Dubois',
          company: 'TechStart SAS',
          text: 'BK Tech transformed our vision into an exceptional application. Professionalism and expertise delivered.'
        },
        {
          name: 'Thomas Martin',
          company: 'FinanceHub',
          text: 'A responsive team that understands our needs. Our trading platform works perfectly.'
        },
        {
          name: 'Sophie Bernard',
          company: 'Digital Learning',
          text: 'Results beyond our expectations. A custom solution that exactly matches our needs.'
        },
        {
          name: 'Alexandre Rousseau',
          company: 'CryptoVision',
          text: 'Flawless crypto development. BK Tech managed the technical complexity brilliantly.'
        },
        {
          name: 'Camille Petit',
          company: 'Analytics Pro',
          text: 'Powerful and intuitive dashboard. The BK Tech team is highly skilled and attentive.'
        },
        {
          name: 'Laurent Dubois',
          company: 'PropTech Solutions',
          text: 'Modern and smooth real estate application. Excellent work from A to Z.'
        }
      ]
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'Let\'s schedule a meeting to discuss your project',
      form: {
        name: 'Full name',
        email: 'Email',
        phone: 'Phone',
        message: 'Message',
        submit: 'Send',
        success: 'Message sent successfully!',
        error: 'Please fill all fields correctly'
      },
      info: {
        email: 'contact@bktech.dev',
        phone: '+33 7 80 91 34 57'
      }
    },
    footer: {
      copyright: '© 2025 BK Tech. All rights reserved.',
      legal: 'Legal Notice'
    }
  }
};
